import * as React from "react";
import { Navbar } from "./navbar";

export const Header: React.FC = () => {
  return <Navbar />;
};
